import axios from "axios";

export const baseURL = import.meta.env.VITE_API_BASE_URL;
const token = import.meta.env.VITE_STRAPI_TOKEN; // Token will now be exposed in frontend

const apiClient = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`, // Token directly used here
  },
  timeout: 10000,
});

let _showLoadingCallback = () => {};
let _hideLoadingCallback = () => {};

export const setGlobalLoadingCallbacks = (showCallback, hideCallback) => {
  _showLoadingCallback = showCallback;
  _hideLoadingCallback = hideCallback;
};

apiClient.interceptors.request.use(
  (config) => {
    _showLoadingCallback();
    // No proxy logic needed for production now
    return config;
  },
  (error) => {
    console.error("API Request Error (before send):", error);
    _hideLoadingCallback();
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => {
    _hideLoadingCallback();
    return response.data;
  },
  (error) => {
    console.error("API Response Error:", error);
    _hideLoadingCallback();
    return Promise.reject(error);
  }
);

export default apiClient;
